// extracted by mini-css-extract-plugin
module.exports = {"diffTitle":"LinkClaimDiff_diffTitle__3tEel","claimDiffContainer":"LinkClaimDiff_claimDiffContainer__1B3IP"};